import * as Role from '../constants/role';
import { isUsuarioUsoMuto } from '../utils';
import { isRoleAuditoriaNsir } from './auditoriaNsirPermission';

const getDigitadorReportAllowlist = () =>
  process.env.REACT_APP_USUARIO_VIEW_DIGITADOR_REPORT?.split(',') ?? [];

const passesDigitadorReportExclusions = ({ authData, userRole }) => {
  if (!authData?.email) return false;
  const role = userRole ?? authData.role;
  return !isUsuarioUsoMuto(authData.email) && !isRoleAuditoriaNsir(role);
};

/**
 * Relatório Digitadores, Minha Digitação, links BI na listagem NSIR.
 * Allowlist env OU ROLE_DIGITADOR (exc. uso mútuo / auditoria NSIR).
 */
export function canViewDigitadorReport({ authData, userRole }) {
  if (!passesDigitadorReportExclusions({ authData, userRole })) return false;
  const allowedEmails = getDigitadorReportAllowlist();
  return (
    allowedEmails.includes(authData.email) || authData.role === Role.DIGITADOR
  );
}

/**
 * Painel global /v2/integracoes — somente allowlist env (gestão).
 * Digitador operacional usa modal NSMP / Minha Digitação.
 */
export function canViewIntegracoesPanel({ authData, userRole }) {
  if (!passesDigitadorReportExclusions({ authData, userRole })) return false;
  return getDigitadorReportAllowlist().includes(authData.email);
}
